<template>
  <div class="center-me" style="margin-bottom: 100px">
    <transition name="company">
      <l-small-modal
        @delete="deleteAllUserCards"
        @click.native="deleteCard = false"
        v-if="deleteCard && products.length"
        style="text-align: left"
        :text="text"
        :data="null"
      >
        <template v-slot:action>
          All existing cards will be lost!
        </template>
      </l-small-modal>
    </transition>

    <div class="center-me">
      <h3 style="font-size: 1.1rem; margin:0; margin-top: 30px; color: #F2F2F2">Simply</h3>
      <div @click="eventy = true">
        <l-toggle v-model="active" />
      </div>
      <div  class="center-me" style="margin-top: 10px">
        <h3 style="font-size: 1.1rem; color: #F2F2F2">all of your TaskBoard cards</h3>
      </div>
    </div>

    <v-btn style="margin-top: 40px" height="44" width="180" class="activeNewBoard mb-3" @click="deleteCards">
      New Task Board
    </v-btn>

    <small style="color: #F2F2F2" class="center-me" v-if="deleteCard && hint">No Task Cards to delete</small>

    <!--<div class="center-me">
      <div
        style="margin-top: 30px; background: #2c3e50; line-height: 2.2; display: flex; justify-content: center"
        class="btn shadow_y"
        @click.prevent="notification"
      >
        <p
          style="color: #fff !important; margin: 0; font-size: 1.1rem; letter-spacing: 0.4px"
          class="btn-text"
        >
          <b>Allow Notifications</b>
        </p>
      </div>
    </div>
    <span>{{payload}}</span>-->
    <div class="center-me" style="margin-top: 40px">
        <h3 style="font-size: 1.1rem; color: #F2F2F2">Switch TaskBoard list</h3>
      </div>
    <div class="center-me mt-5">
      <v-btn @click="switchState(newState)" class="main">switch</v-btn>
    </div>

  </div>
</template>

<script>
import lToggle from "@/components/toggle";
import lButton from "@/components/button";
import lAdvertise from "@/components/advertisment";
import lSmallModal from "@/components/smallModal";
import { auth, database } from "@/firebase/async-firestore";
import { mapState, mapActions } from "vuex";
import { notify } from "@/filters";
import firebase from "firebase/app";
import "firebase/messaging";

export default {
  components: {
    lAdvertise,
    lSmallModal,
    lToggle,
    lButton
  },
  data() {
    return {
      payload: null,
      text: "Delete all cards and start form scratch?",
      deleteCard: false,
      active: null,
      eventy: false,
      hint: false,
      styling: 'activeNewBoard',
      textStyle: 'activeText',
      newState: null
    };
  },
  computed: {
    ...mapState("posts", ["products"]),
    ...mapState("app", ["appVersion"]),
    ...mapState("user", ["userProfile", "currentUser"]),
    my() {
      return this.$store.state.posts.active;
    }
  },
  watch: {
    active() {
      this.setState();
    }
  },
  mounted() {
    const getState = window.localStorage.getItem("state");
    this.active = JSON.parse(getState);
  },
  methods: {
    async switchState(data) {
      this.newState = !this.newState
     var selectedContent;
      if(data === true) {
        selectedContent = false
      } else {
        selectedContent = true
      }
      const path = 'state'
      const userId = this.currentUser.uid

      this.$store.dispatch('random/triggerState', {
          selectedContent,
          userId,
          path,
      })
      .then(() => {
        this.$router.push('/')
      })
    },
    async setState() {
      if (this.eventy === true) {
        if (this.active === true) {
          window.localStorage.setItem("state", JSON.parse(true));

          this.$store.dispatch("posts/activateCard", {
            root: true
          })
         .then(async () => {

           this.$router.push({name: 'home'})
          })
         
        } else if (this.active === false) {
          window.localStorage.setItem("state", JSON.parse(false));

          this.$store.dispatch("posts/deActiveAllCards", {
            root: true
          })
          .then(async () => {

           this.$router.push({name: 'home'})
          })
        }
      }
    },
    notification() {
      notify;
      this.requestNotificationsPermissions();
    },
    // fcm
    requestNotificationsPermissions() {
      console.log("Requesting notifications permission...");
      firebase
        .messaging()
        .requestPermission()
        .then(() => {
          // Notification permission granted.
          this.saveMessagingDeviceToken();
          firebase.messaging().onMessage(payload => {
            console.log("Message received. ", payload);
          });
        })
        .catch(error => {
          console.error("Unable to get permission to notify.", error);
        });
    },
    saveMessagingDeviceToken() {
      firebase
        .messaging()
        .getToken()
        .then(async currentToken => {
          if (currentToken) {
            // If no notificationTokens inside db we exit the function.
            // get old fcm token
            return (await database())
              .ref("/users/" + (await auth()).currentUser.uid)
              .once("value")
              .then(async snapshot => {
                if (snapshot.val()) {
                  var oldToken = Object.keys(snapshot.val().notificationTokens);
                  console.log(oldToken);
                  console.log(oldToken[0]);
                  if (oldToken[0] !== currentToken) {
                    console.log("remove token");
                    (await database())
                      .ref(
                        "/users/" +
                          (await auth()).currentUser.uid +
                          "/notificationTokens/" +
                          oldToken
                      )
                      .remove()
                      .then(async () => {
                        console.log("new token added after oldToken deleded");
                        // Saving the Device Token to the database.
                        (await database())
                          .ref(
                            "users/" +
                              (await auth()).currentUser.uid +
                              "/notificationTokens/" +
                              currentToken
                          )
                          .set(true);
                      });
                  } else {
                    console.log("euqal");
                    return;
                  }
                } else if (!snapshot.val()) {
                  console.log("no token");
                  // Saving the Device Token to the database.
                  (await database())
                    .ref(
                      "users/" +
                        (await auth()).currentUser.uid +
                        "/notificationTokens/" +
                        currentToken
                    )
                    .set(true);
                }
              });
          } else {
            console.log("activate Notification");
            // Need to request permissions to show notifications.
            this.requestNotificationsPermissions();
          }
        })
        .catch(error => {
          console.error("Unable to get messaging token.", error);
        });
    },
    ...mapActions("posts", [
      "deleteAllUserCards",
      "activateCard",
      "deActiveAllCards"
    ]),
    deleteCards() {
      if(this.products.length) {
        this.deleteCard = true;
        this.hint = false
      } else {
        this.deleteCard = true;
        this.hint = true
        setTimeout(() => {
        this.deleteCard = false;
        this.hint = false
        }, 2000)
      }
    }
  }
};
</script>

<style>
.activeNewBoard {
  background: #F2F2F2 !important;
  color: #8E8E8E !important;
}
</style>